/* eslint-disable @typescript-eslint/no-magic-numbers */
import { powerConfig, nonePower } from './config';

const perimeter = Math.PI * 2 * 70;
const totalTime = 1000;

// rate 是小数
function setPosition(rateInput) {
  const rate = Math.min(1, rateInput);
  const eleCircles = document.querySelectorAll<HTMLElement>('#power-svg .circle-group circle');
  const eleDotted = document.querySelectorAll<HTMLElement>('#power-svg .circle-dotted');
  eleCircles?.[0]?.setAttribute?.('stroke-dasharray', `${(perimeter * rate).toFixed(2)} ${perimeter}`);

  const bRate = Math.min(rate, 0.5);
  eleCircles?.[1]?.setAttribute?.('stroke-dasharray', `${(perimeter * bRate).toFixed(2)} ${perimeter}`);

  if (eleDotted?.[0]) {
    eleDotted[0].style.transform = `rotate(${360 * rate}deg)`;
    eleDotted[0].style.transformOrigin = 'center';
  }
}

export function computeValue(rate, key) {
  if (!rate) {
    return nonePower[key];
  }
  for (let i = powerConfig().length - 1; i >= 0; i--) {
    if (rate >= powerConfig()[i].value) {
      return powerConfig()[i][key];
    }
  }

  return '';
}

export const changePowerAnimation = function (target = 0, old = 0) {
  if (target === old) {
    return;
  }

  const totalLength = target - old;

  const time = Math.abs(totalLength * totalTime);

  const oldColor = computeValue(old, 'dotColor');
  const targetColor = computeValue(target, 'dotColor');

  if (oldColor !== targetColor) {
    const eleDottedWithColor = document.querySelectorAll<HTMLElement>('#power-svg .circle-dotted circle');
    if (eleDottedWithColor?.[1]) {
      eleDottedWithColor[1].style.stroke = targetColor;
      eleDottedWithColor[1].style.transition = `stroke ${time}ms`;
    }
  }

  const start = performance.now();
  function step(timestamp: number) {
    const timeRate = (timestamp - start) / time;
    const curr = totalLength * timeRate + Number(old);
    setPosition(curr);
    if (timeRate < 1) {
      window.requestAnimationFrame(step);
    }
  }
  step(start + 1);
};
